import { render, staticRenderFns } from "./dayiOtRecord.vue?vue&type=template&id=1cf76667&scoped=true&"
import script from "./dayiOtRecord.vue?vue&type=script&lang=js&"
export * from "./dayiOtRecord.vue?vue&type=script&lang=js&"
import style0 from "./dayiOtRecord.vue?vue&type=style&index=0&id=1cf76667&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf76667",
  null
  
)

export default component.exports